import React, { forwardRef, useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material';
import { FormControl, Input, Button, Chip } from '@mui/material'
import { useStateValue } from "../StateProvider";
import { useInput } from "../hooks/inputHook";
import { actionTypes } from "../reducer";
import StepButtons from '../components/StepButtons'
import "../styles/documents.css";
import axios from '../axios';
import { List } from "@mui/icons-material";

function Documents({ },ref) {
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfFileError, setPdfFileError] = useState('');
  const fileType = ['application/pdf'];

  const [{ applicantDetails }, dispatch] = useStateValue();
  const [additionalInvoice, setAdditionalInvoice] = useState([]);
  const [additionalVS, setAdditionalVS] = useState([]);
  const [additionalDL, setAdditionalDL] = useState([]);
  const [additionalDocs, setAdditionalDocs] = useState([]);

  const [url, setUrl] = React.useState('');
  const [additionalInvoiceFile, setAdditionalInvoiceFile] = useState(applicantDetails?.additional_invoice_files || []);
  const [additionalVSFile, setAdditionalVSFile] = useState(applicantDetails?.additional_vs_files || []);
  const [additionalDLFile, setAdditionalDLFile] = useState(applicantDetails?.additional_dl_files || []);
  const [additionalDocsFile, setAdditionalDocsFile] = useState(applicantDetails?.additional_docs_files || []);

  const [additionalInvoiceFilePayload, setAdditionalInvoiceFilePayload] = useState(applicantDetails?.additional_invoice_payload || []);
  const [additionalVSFilePayload, setAdditionalVSFilePayload] = useState(applicantDetails?.additional_vs_payload || []);
  const [additionalDLFilePayload, setAdditionalDLFilePayload] = useState(applicantDetails?.additional_dl_payload || []);
  const [additionalDocsFilePayload, setAdditionalDocsFilePayload] = useState(applicantDetails?.additional_docs_payload || []);

  const [psSaveDocs, setPSSaveDocs] = useState([]);
  const [psAdditionalInvoice, setPSAdditionalInvoice] = useState([]);
  const [psAdditionalVS, setPSAdditionalVS] = useState([]);
  const [psAdditionalDL, setPSAdditionalDL] = useState([]);
  const [psAdditionalDocs, setPSAdditionalDocs] = useState([]);

  

  const onInputChangeInvoiceDocs = (e) => {
    //console.log("Change invoice",e.target.files);
    setAdditionalInvoice(e.target.files);
    let selectedFile = e.target.files;
    setAdditionalInvoiceFilePayload(selectedFile);
    let fileDataArray = [];

    if (selectedFile) {
      for (var i = 0; i < selectedFile.length; i++) {
        let fileData = [];
        fileData['filename'] = selectedFile[i].name;

        let reader = new FileReader();
        if (selectedFile[i] && fileType.includes(selectedFile[i].type)) {
          reader.readAsDataURL(selectedFile[i]);
          reader.onloadend = (e) => {
            fileData['data'] = e.target.result;
            setPdfFile(e.target.result);
            setPdfFileError('');
          }
        }
        else {
          setPdfFile(null);
          setPdfFileError('Please select valid pdf file');
        }

        fileDataArray.push(fileData);
      }
      // console.log("filedatas:", fileDataArray);
      setAdditionalInvoiceFile(fileDataArray);
    } else {
      //console.log('select your file');
    }
  };

  const onInputChangeVSDocs = (e) => {
    // console.log(e.target.files);
    setAdditionalVS(e.target.files);
    let selectedFile = e.target.files;
    setAdditionalVSFilePayload(selectedFile);
    let fileDataArray = [];

    if (selectedFile) {
      for (var i = 0; i < selectedFile.length; i++) {
        let fileData = [];
        fileData['filename'] = selectedFile[i].name;

        let reader = new FileReader();
        if (selectedFile[i] && fileType.includes(selectedFile[i].type)) {
          reader.readAsDataURL(selectedFile[i]);
          reader.onloadend = (e) => {
            fileData['data'] = e.target.result;
            setPdfFile(e.target.result);
            setPdfFileError('');
          }
        }
        else {
          setPdfFile(null);
          setPdfFileError('Please select valid pdf file');
        }

        fileDataArray.push(fileData);
      }
      // console.log("filedatas:", fileDataArray);
      setAdditionalVSFile(fileDataArray);
    } else {
      //console.log('select your file');
    }
  };

  const onInputChangeDLDocs = (e) => {
    // console.log(e.target.files);
    setAdditionalDL(e.target.files);
    let selectedFile = e.target.files;
    setAdditionalDLFilePayload(selectedFile);
    let fileDataArray = [];

    if (selectedFile) {
      for (var i = 0; i < selectedFile.length; i++) {
        let fileData = [];
        fileData['filename'] = selectedFile[i].name;

        let reader = new FileReader();
        if (selectedFile[i] && fileType.includes(selectedFile[i].type)) {
          reader.readAsDataURL(selectedFile[i]);
          reader.onloadend = (e) => {
            fileData['data'] = e.target.result;
            setPdfFile(e.target.result);
            setPdfFileError('');
          }
        }
        else {
          setPdfFile(null);
          setPdfFileError('Please select valid pdf file');
        }

        fileDataArray.push(fileData);
      }
      // console.log("filedatas:", fileDataArray);
      setAdditionalDLFile(fileDataArray);
    } else {
      //console.log('select your file');
    }
  };

  const onInputChangeAdditionalDocs = (e) => {
    // console.log(e.target.files);
    setAdditionalDocs(e.target.files);
    let selectedFile = e.target.files;
    setAdditionalDocsFilePayload(selectedFile);
    let fileDataArray = [];

    if (selectedFile) {
      for (var i = 0; i < selectedFile.length; i++) {
        let fileData = [];
        fileData['filename'] = selectedFile[i].name;

        let reader = new FileReader();
        if (selectedFile[i] && fileType.includes(selectedFile[i].type)) {
          reader.readAsDataURL(selectedFile[i]);
          reader.onloadend = (e) => {
            fileData['data'] = e.target.result;
            setPdfFile(e.target.result);
            setPdfFileError('');
          }
        }
        else {
          setPdfFile(null);
          setPdfFileError('Please select valid pdf file');
        }

        fileDataArray.push(fileData);
      }
      // console.log("filedatas:", fileDataArray);
      setAdditionalDocsFile(fileDataArray);
    } else {
      //console.log('select your file');
    }
  };

  const uploadNewInvoice = (e) => {
    setAdditionalInvoice([...additionalInvoice, ...e.target.files]);
    let selectedFile = e.target.files;
    setAdditionalInvoiceFilePayload([...additionalInvoiceFilePayload, ...selectedFile]);
    let fileDataArray = [];

    if (selectedFile) {
      for (var i = 0; i < selectedFile.length; i++) {
        let fileData = [];
        fileData['filename'] = selectedFile[i].name;

        let reader = new FileReader();
        if (selectedFile[i] && fileType.includes(selectedFile[i].type)) {
          reader.readAsDataURL(selectedFile[i]);
          reader.onloadend = (e) => {
            fileData['data'] = e.target.result;
            setPdfFile(e.target.result);
            setPdfFileError('');
          }
        }
        else {
          setPdfFile(null);
          setPdfFileError('Please select valid pdf file');
        }

        fileDataArray.push(fileData);
      }
      // console.log("filedatas:", fileDataArray);
      setAdditionalInvoiceFile([...additionalInvoiceFile, ...fileDataArray]);
    } else {
      //console.log('select your file');
    }

  }

  const uploadNewVS = (e) => {
    // console.log(e.target.files);
    setAdditionalVS([...additionalVS, ...e.target.files]);
    let selectedFile = e.target.files;
    setAdditionalVSFilePayload([...additionalVSFilePayload, ...selectedFile]);
    let fileDataArray = [];

    if (selectedFile) {
      for (var i = 0; i < selectedFile.length; i++) {
        let fileData = [];
        fileData['filename'] = selectedFile[i].name;

        let reader = new FileReader();
        if (selectedFile[i] && fileType.includes(selectedFile[i].type)) {
          reader.readAsDataURL(selectedFile[i]);
          reader.onloadend = (e) => {
            fileData['data'] = e.target.result;
            setPdfFile(e.target.result);
            setPdfFileError('');
          }
        }
        else {
          setPdfFile(null);
          setPdfFileError('Please select valid pdf file');
        }

        fileDataArray.push(fileData);
      }
      // console.log("filedatas:", fileDataArray);
      setAdditionalVSFile([...additionalVSFile, ...fileDataArray]);
    } else {
      //console.log('select your file');
    }

  }

  const uploadNewDL = (e) => {
    // console.log(e.target.files);
    setAdditionalDL([...additionalDL, ...e.target.files]);
    let selectedFile = e.target.files;
    setAdditionalDLFilePayload([...additionalDLFilePayload, ...selectedFile]);
    let fileDataArray = [];

    if (selectedFile) {
      for (var i = 0; i < selectedFile.length; i++) {
        let fileData = [];
        fileData['filename'] = selectedFile[i].name;

        let reader = new FileReader();
        if (selectedFile[i] && fileType.includes(selectedFile[i].type)) {
          reader.readAsDataURL(selectedFile[i]);
          reader.onloadend = (e) => {
            fileData['data'] = e.target.result;
            setPdfFile(e.target.result);
            setPdfFileError('');
          }
        }
        else {
          setPdfFile(null);
          setPdfFileError('Please select valid pdf file');
        }

        fileDataArray.push(fileData);
      }
      // console.log("filedatas:", fileDataArray);
      setAdditionalDLFile([...additionalDLFile, ...fileDataArray]);
    } else {
      //console.log('select your file');
    }

  }

  const uploadNewAF = (e) => {
    // console.log(e.target.files);
    setAdditionalDocs([...additionalDocs, ...e.target.files]);
    let selectedFile = e.target.files;
    setAdditionalDocsFilePayload([...additionalDocsFilePayload, ...selectedFile]);
    let fileDataArray = [];

    if (selectedFile) {
      for (var i = 0; i < selectedFile.length; i++) {
        let fileData = [];
        fileData['filename'] = selectedFile[i].name;

        let reader = new FileReader();
        if (selectedFile[i] && fileType.includes(selectedFile[i].type)) {
          reader.readAsDataURL(selectedFile[i]);
          reader.onloadend = (e) => {
            fileData['data'] = e.target.result;
            setPdfFile(e.target.result);
            setPdfFileError('');
          }
        }
        else {
          setPdfFile(null);
          setPdfFileError('Please select valid pdf file');
        }

        fileDataArray.push(fileData);
      }
      // console.log("filedatas:", fileDataArray);
      setAdditionalDocsFile([...additionalDocsFile, ...fileDataArray]);
    } else {
      //console.log('select your file');
    }

  }

  const deleteFileCurrentInvoice = (file) => {
    // console.log(additionalDocsFile.indexOf(file));
    setAdditionalInvoiceFile(additionalInvoiceFile.filter(item => item !== file));
    let payloadArray = [...additionalInvoiceFilePayload]
    payloadArray.splice(additionalInvoiceFile.indexOf(file), 1)
    setAdditionalInvoiceFilePayload(payloadArray);
  }

  const deleteFileCurrentVS = (file) => {
    // console.log(additionalDocsFile.indexOf(file));
    setAdditionalVSFile(additionalVSFile.filter(item => item !== file));
    let payloadArray = [...additionalVSFilePayload]
    payloadArray.splice(additionalVSFile.indexOf(file), 1)
    setAdditionalVSFilePayload(payloadArray);
  }

  const deleteFileCurrentDL = (file) => {
    // console.log(additionalDocsFile.indexOf(file));
    setAdditionalDLFile(additionalDLFile.filter(item => item !== file));
    let payloadArray = [...additionalDLFilePayload]
    payloadArray.splice(additionalDLFile.indexOf(file), 1)
    setAdditionalDLFilePayload(payloadArray);
  }

  const deleteFileCurrent = (file) => {
    // console.log(additionalDocsFile.indexOf(file));
    setAdditionalDocsFile(additionalDocsFile.filter(item => item !== file));
    let payloadArray = [...additionalDocsFilePayload]
    payloadArray.splice(additionalDocsFile.indexOf(file), 1)
    setAdditionalDocsFilePayload(payloadArray);
  }

  const clearInvoice = () => {
    setAdditionalInvoiceFile([]);
    setAdditionalInvoiceFilePayload([]);
  }

  const clearNewInvoice = () => {
    dispatch({
      type: actionTypes.SET_APPLICANT_DETAILS,
      applicantDetails: {
        ...applicantDetails,
        additional_invoice: null,
        additional_invoice_files: null,
        additional_invoice_payload: null,
        additional_vs: additionalVS ? additionalVS : applicantDetails?.additional_vs,
        additional_vs_files: additionalVSFile?.length > 0 ? additionalVSFile : applicantDetails?.additional_vs_files,
        additional_vs_payload: additionalVSFilePayload ? additionalVSFilePayload : applicantDetails?.additional_vs_payload,
        additional_dl: additionalDL ? additionalDL : applicantDetails?.additional_dl,
        additional_dl_files: additionalDLFile?.length > 0 ? additionalDLFile : applicantDetails?.additional_dl_files,
        additional_dl_payload: additionalDLFilePayload ? additionalDLFilePayload : applicantDetails?.additional_dl_payload,
        additional_docs: additionalDocs ? additionalDocs : applicantDetails?.additional_docs,
        additional_docs_files: additionalDocsFile?.length > 0 ? additionalDocsFile : applicantDetails?.additional_docs_files,
        additional_docs_payload: additionalDocsFilePayload ? additionalDocsFilePayload : applicantDetails?.additional_docs_payload,
      },
    });
  }

  const clearVS = () => {
    setAdditionalVSFile([]);
    setAdditionalVSFilePayload([]);
  }

  const clearNewVS = () => {
    dispatch({
      type: actionTypes.SET_APPLICANT_DETAILS,
      applicantDetails: {
        ...applicantDetails,
        additional_vs: null,
        additional_vs_files: null,
        additional_vs_payload: null,
        additional_invoice: additionalInvoice ? additionalInvoice : applicantDetails?.additional_invoice,
        additional_invoice_files: additionalInvoiceFile?.length > 0 ? additionalInvoiceFile : applicantDetails?.additional_invoice_files,
        additional_invoice_payload: additionalInvoiceFilePayload ? additionalInvoiceFilePayload : applicantDetails?.additional_invoice_payload,
        additional_dl: additionalDL ? additionalDL : applicantDetails?.additional_dl,
        additional_dl_files: additionalDLFile?.length > 0 ? additionalDLFile : applicantDetails?.additional_dl_files,
        additional_dl_payload: additionalDLFilePayload ? additionalDLFilePayload : applicantDetails?.additional_dl_payload,
        additional_docs: additionalDocs ? additionalDocs : applicantDetails?.additional_docs,
        additional_docs_files: additionalDocsFile?.length > 0 ? additionalDocsFile : applicantDetails?.additional_docs_files,
        additional_docs_payload: additionalDocsFilePayload ? additionalDocsFilePayload : applicantDetails?.additional_docs_payload,
      },
    });
  }

  const clearDL = () => {
    setAdditionalDLFile([]);
    setAdditionalDLFilePayload([]);
  }

  const clearNewDL = () => {
    dispatch({
      type: actionTypes.SET_APPLICANT_DETAILS,
      applicantDetails: {
        ...applicantDetails,
        additional_dl: null,
        additional_dl_files: null,
        additional_dl_payload: null,
        additional_invoice: additionalInvoice ? additionalInvoice : applicantDetails?.additional_invoice,
        additional_invoice_files: additionalInvoiceFile?.length > 0 ? additionalInvoiceFile : applicantDetails?.additional_invoice_files,
        additional_invoice_payload: additionalInvoiceFilePayload ? additionalInvoiceFilePayload : applicantDetails?.additional_invoice_payload,
        additional_vs: additionalVS ? additionalVS : applicantDetails?.additional_vs,
        additional_vs_files: additionalVSFile?.length > 0 ? additionalVSFile : applicantDetails?.additional_vs_files,
        additional_vs_payload: additionalVSFilePayload ? additionalVSFilePayload : applicantDetails?.additional_vs_payload,
        additional_docs: additionalDocs ? additionalDocs : applicantDetails?.additional_docs,
        additional_docs_files: additionalDocsFile?.length > 0 ? additionalDocsFile : applicantDetails?.additional_docs_files,
        additional_docs_payload: additionalDocsFilePayload ? additionalDocsFilePayload : applicantDetails?.additional_docs_payload,
      },
    });
  }

  const clearOAR = () => {
    setAdditionalDocsFile([]);
    setAdditionalDocsFilePayload([]);
  }

  const clearNewOAR = () => {
    dispatch({
      type: actionTypes.SET_APPLICANT_DETAILS,
      applicantDetails: {
        ...applicantDetails,
        additional_docs: null,
        additional_docs_files: null,
        additional_docs_payload: null,
        additional_invoice: additionalInvoice ? additionalInvoice : applicantDetails?.additional_invoice,
        additional_invoice_files: additionalInvoiceFile?.length > 0 ? additionalInvoiceFile : applicantDetails?.additional_invoice_files,
        additional_invoice_payload: additionalInvoiceFilePayload ? additionalInvoiceFilePayload : applicantDetails?.additional_invoice_payload,
        additional_vs: additionalVS ? additionalVS : applicantDetails?.additional_vs,
        additional_vs_files: additionalVSFile?.length > 0 ? additionalVSFile : applicantDetails?.additional_vs_files,
        additional_vs_payload: additionalVSFilePayload ? additionalVSFilePayload : applicantDetails?.additional_vs_payload,
        additional_dl: additionalDL ? additionalDL : applicantDetails?.additional_dl,
        additional_dl_files: additionalDLFile?.length > 0 ? additionalDLFile : applicantDetails?.additional_dl_files,
        additional_dl_payload: additionalDLFilePayload ? additionalDLFilePayload : applicantDetails?.additional_dl_payload,
      },
    });
  }

  const onUpdateDocumentsInfo = () => {
    dispatch({
      type: actionTypes.SET_APPLICANT_DETAILS,
      applicantDetails: {
        ...applicantDetails,
        //invoice: invoice ? invoice : applicantDetails?.invoice,
        //invoice_file: invoiceFile ? invoiceFile : applicantDetails?.invoice_file,
        //invoice_payload: invoiceFilePayload ? invoiceFilePayload : applicantDetails?.invoice_payload,
        additional_invoice: additionalInvoice ? additionalInvoice : applicantDetails?.additional_invoice,
        additional_invoice_files: additionalInvoiceFile?.length > 0 ? additionalInvoiceFile : applicantDetails?.additional_invoice_files,
        additional_invoice_payload: additionalInvoiceFilePayload ? additionalInvoiceFilePayload : applicantDetails?.additional_invoice_payload,
        additional_vs: additionalVS ? additionalVS : applicantDetails?.additional_vs,
        additional_vs_files: additionalVSFile?.length > 0 ? additionalVSFile : applicantDetails?.additional_vs_files,
        additional_vs_payload: additionalVSFilePayload ? additionalVSFilePayload : applicantDetails?.additional_vs_payload,
        additional_dl: additionalDL ? additionalDL : applicantDetails?.additional_dl,
        additional_dl_files: additionalDLFile?.length > 0 ? additionalDLFile : applicantDetails?.additional_dl_files,
        additional_dl_payload: additionalDLFilePayload ? additionalDLFilePayload : applicantDetails?.additional_dl_payload,
        additional_docs: additionalDocs ? additionalDocs : applicantDetails?.additional_docs,
        additional_docs_files: additionalDocsFile?.length > 0 ? additionalDocsFile : applicantDetails?.additional_docs_files,
        additional_docs_payload: additionalDocsFilePayload ? additionalDocsFilePayload : applicantDetails?.additional_docs_payload,
      },
    });

    return true;
  }

  return (
    <Grid container height={'90vh'}>
      <Typography variant='h5'>
        In order to expedite your application, please attach the following information. If you don’t have these items, please proceed as they will be requested after submission.
      </Typography>
      <Grid item xs={12} md={12} lg={5.5} xl={5.5} marginTop={2}>
        <h3 class="fileUploadTitle">Invoice</h3>
        {
          applicantDetails?.additional_invoice_files?.length > 0 ? (
            <>
              <Grid sx={{ display: { xs: 'block', sm: 'none' }, marginTop: '20px' }}>
                <div class="selectedFiles">Selected File/Files:</div>
                {additionalInvoiceFile.map((AdditionalInvoiceFile) => (
                  <div class="fileUploadDocTitle">
                    <b>{AdditionalInvoiceFile?.filename}<Button onClick={() => deleteFileCurrentInvoice(AdditionalInvoiceFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                  </div>
                ))}
                <Button style={{ marginRight: '2.5px' }} component="label" variant="contained" className="fileUploadButton">
                  Add Files
                  <input
                    hidden
                    multiple
                    type="file"
                    onChange={uploadNewInvoice}
                    name="setAdditionalMoreInvoice"
                    id="docsInvoice"
                    disableUnderline={true}
                  />
                </Button>
                <Button style={{ marginLeft: '2.5px' }} onClick={clearNewInvoice} variant="outlined" className="fileClearButton">
                  Clear Files
                </Button>
              </Grid>
              <Grid sx={{ display: { xs: 'none', sm: 'block' } }}>
                <div className='fileContainter'>
                  <div class="selectedFiles">Selected File/Files:</div>
                  {additionalInvoiceFile.map((AdditionalInvoiceFile) => (
                    <div class="fileUploadDocTitle">
                      <b>{AdditionalInvoiceFile?.filename}<Button onClick={() => deleteFileCurrentInvoice(AdditionalInvoiceFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                    </div>
                  ))}
                  <Button style={{ marginRight: '2.5px' }} component="label" variant="contained" className="fileUploadButton">
                    Add Files
                    <input
                      hidden
                      multiple
                      type="file"
                      onChange={uploadNewInvoice}
                      name="setAdditionalMoreInvoice"
                      id="docsInvoice"
                      disableUnderline={true}
                    />
                  </Button>
                  <Button style={{ marginLeft: '2.5px' }} onClick={clearNewInvoice} variant="outlined" className="fileClearButton">
                    Clear Files
                  </Button>

                  {/* <Button onClick={uploadNewAF} class='fileUploadButton'>Upload More Files</Button> */}
                </div>
              </Grid>

            </>

          ) : (
            additionalInvoiceFile.length > 0 ? (
              <>
                <Grid sx={{ display: { xs: 'block', sm: 'none' }, marginTop: '20px' }}>
                  {additionalInvoiceFile.map((AdditionalInvoiceFile) => (
                    <div class="fileUploadDocTitle">
                      <b>{AdditionalInvoiceFile?.filename}<Button onClick={() => deleteFileCurrentInvoice(AdditionalInvoiceFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                    </div>
                  ))}
                  <Button variant="contained" component="label">
                    Add Files
                    <input
                      hidden
                      multiple
                      type="file"
                      onChange={uploadNewInvoice}
                      name="setAdditionalMoreInvoice"
                      id="docsInvoice"
                      disableUnderline={true}
                    />
                  </Button>
                </Grid>
                <Grid sx={{ display: { xs: 'none', sm: 'block' } }}>
                  <div className='fileContainter'>
                    <div class="selectedFiles">Selected File/Files:</div>
                    {additionalInvoiceFile.map((AdditionalInvoiceFile) => (
                      <div class="fileUploadDocTitle">
                        <b>{AdditionalInvoiceFile?.filename}<Button onClick={() => deleteFileCurrentInvoice(AdditionalInvoiceFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                      </div>
                    ))}
                    <Button variant="contained" component="label">
                      Add Files
                      <input
                        hidden
                        multiple
                        type="file"
                        onChange={uploadNewInvoice}
                        name="setAdditionalMoreInvoice"
                        id="docsInvoice"
                        disableUnderline={true}
                      />
                    </Button>
                    <Button onClick={clearInvoice} variant="outlined" color="error">
                      Clear
                    </Button>
                  </div>
                </Grid>
              </>
            ) : (
              <>
                <Grid sx={{ display: { xs: 'block', sm: 'none' }, marginTop: '20px' }}>
                  <Button
                    variant="contained"
                    component="label"
                  >
                    Upload Document
                    <input
                      className="form-control"
                      type="file"
                      onChange={onInputChangeInvoiceDocs}
                      name="setAdditionalInvoice"
                      id="docsInvoice"
                      inputProps={{ multiple: true }}
                      hidden
                      disableUnderline={true}
                    />
                  </Button>
                </Grid>
                <Grid sx={{ display: { xs: 'none', sm: 'block' } }}>
                  <div class="form-group files">
                    <FormControl required={true}
                      fullWidth>
                      <Input
                        className="form-control"
                        type="file"
                        onChange={onInputChangeInvoiceDocs}
                        name="setAdditionalInvoice"
                        id="docsInvoice"
                        inputProps={{ multiple: true }}
                        disableUnderline={true}
                      />
                    </FormControl>
                  </div>
                </Grid>
              </>
            )
          )
        }
        <Grid container paddingLeft={4}>
          <Grid item xs={12}>
          {psAdditionalInvoice.map((item, index) => (
                <Typography sx={{ textAlign: 'left', fontSize: '12px' }}>File Name: {item?.filename}</Typography>
              ))}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={12} lg={5.5} xl={5.5} marginTop={2}>
        <h3 class="fileUploadTitle">Vehicle Specifications</h3>
        {
          applicantDetails?.additional_vs_files?.length > 0 ? (
            <>
              <Grid sx={{ display: { xs: 'block', sm: 'none' }, marginTop: '20px' }}>
                <div class="selectedFiles">Selected File/Files:</div>
                {additionalVSFile.map((AdditionalVSFile) => (
                  <div class="fileUploadDocTitle">
                    <b>{AdditionalVSFile?.filename}<Button onClick={() => deleteFileCurrentVS(AdditionalVSFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                  </div>
                ))}
                <Button style={{ marginRight: '2.5px' }} component="label" variant="contained" className="fileUploadButton">
                  Add Files
                  <input
                    hidden
                    multiple
                    type="file"
                    onChange={uploadNewVS}
                    name="setAdditionalMoreVS"
                    id="docsVS"
                    disableUnderline={true}
                  />
                </Button>
                <Button style={{ marginLeft: '2.5px' }} onClick={clearNewVS} variant="outlined" className="fileClearButton">
                  Clear Files
                </Button>
              </Grid>
              <Grid sx={{ display: { xs: 'none', sm: 'block' } }}>
                <div className='fileContainter'>
                  <div class="selectedFiles">Selected File/Files:</div>
                  {additionalVSFile.map((AdditionalVSFile) => (
                    <div class="fileUploadDocTitle">
                      <b>{AdditionalVSFile?.filename}<Button onClick={() => deleteFileCurrentVS(AdditionalVSFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                    </div>
                  ))}
                  <Button style={{ marginRight: '2.5px' }} component="label" variant="contained" className="fileUploadButton">
                    Add Files
                    <input
                      hidden
                      multiple
                      type="file"
                      onChange={uploadNewVS}
                      name="setAdditionalMoreVS"
                      id="docsVS"
                      disableUnderline={true}
                    />
                  </Button>
                  <Button style={{ marginLeft: '2.5px' }} onClick={clearNewVS} variant="outlined" className="fileClearButton">
                    Clear Files
                  </Button>

                  {/* <Button onClick={uploadNewAF} class='fileUploadButton'>Upload More Files</Button> */}
                </div>
              </Grid>

            </>

          ) : (
            additionalVSFile.length > 0 ? (
              <>
                <Grid sx={{ display: { xs: 'block', sm: 'none' }, marginTop: '20px' }}>
                  {additionalVSFile.map((AdditionalVSFile) => (
                    <div class="fileUploadDocTitle">
                      <b>{AdditionalVSFile?.filename}<Button onClick={() => deleteFileCurrentVS(AdditionalVSFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                    </div>
                  ))}
                  <Button variant="contained" component="label">
                    Add Files
                    <input
                      hidden
                      multiple
                      type="file"
                      onChange={uploadNewVS}
                      name="setAdditionalMoreVS"
                      id="docsVS"
                      disableUnderline={true}
                    />
                  </Button>
                </Grid>
                <Grid sx={{ display: { xs: 'none', sm: 'block' } }}>
                  <div className='fileContainter'>
                    <div class="selectedFiles">Selected File/Files:</div>
                    {additionalVSFile.map((AdditionalVSFile) => (
                      <div class="fileUploadDocTitle">
                        <b>{AdditionalVSFile?.filename}<Button onClick={() => deleteFileCurrentVS(AdditionalVSFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                      </div>
                    ))}
                    <Button variant="contained" component="label">
                      Add Files
                      <input
                        hidden
                        multiple
                        type="file"
                        onChange={uploadNewVS}
                        name="setAdditionalMoreVS"
                        id="docsVS"
                        disableUnderline={true}
                      />
                    </Button>
                    <Button onClick={clearVS} variant="outlined" color="error">
                      Clear
                    </Button>
                  </div>
                </Grid>
              </>
            ) : (
              <>
                <Grid sx={{ display: { xs: 'block', sm: 'none' }, marginTop: '20px' }}>
                  <Button
                    variant="contained"
                    component="label"
                  >
                    Upload Document
                    <input
                      className="form-control"
                      type="file"
                      onChange={onInputChangeVSDocs}
                      name="setAdditionalVS"
                      id="docsVS"
                      inputProps={{ multiple: true }}
                      hidden
                      disableUnderline={true}
                    />
                  </Button>
                </Grid>
                <Grid sx={{ display: { xs: 'none', sm: 'block' } }}>
                  <div class="form-group files">
                    <FormControl required={true}
                      fullWidth>
                      <Input
                        className="form-control"
                        type="file"
                        onChange={onInputChangeVSDocs}
                        name="setAdditionalDocs"
                        id="docsVS"
                        inputProps={{ multiple: true }}
                        disableUnderline={true}
                      />
                    </FormControl>
                  </div>
                </Grid>
              </>
            )
          )
        }
        <Grid container paddingLeft={4}>
          <Grid item xs={12}>
          {psAdditionalVS.map((item, index) => (
                <Typography sx={{ textAlign: 'left', fontSize: '12px' }}>File Name: {item?.filename}</Typography>
              ))}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={12} lg={5.5} xl={5.5} marginTop={2}>
        <h3 class="fileUploadTitle">Drivers License</h3>
        {
          applicantDetails?.additional_dl_files?.length > 0 ? (
            <>
              <Grid sx={{ display: { xs: 'block', sm: 'none' }, marginTop: '20px' }}>
                <div class="selectedFiles">Selected File/Files:</div>
                {additionalDLFile.map((AdditionalDLFile) => (
                  <div class="fileUploadDocTitle">
                    <b>{AdditionalDLFile?.filename}<Button onClick={() => deleteFileCurrentDL(AdditionalDLFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                  </div>
                ))}
                <Button style={{ marginRight: '2.5px' }} component="label" variant="contained" className="fileUploadButton">
                  Add Files
                  <input
                    hidden
                    multiple
                    type="file"
                    onChange={uploadNewDL}
                    name="setAdditionalMoreDL"
                    id="docsDL"
                    disableUnderline={true}
                  />
                </Button>
                <Button style={{ marginLeft: '2.5px' }} onClick={clearNewDL} variant="outlined" className="fileClearButton">
                  Clear Files
                </Button>
              </Grid>
              <Grid sx={{ display: { xs: 'none', sm: 'block' } }}>
                <div className='fileContainter'>
                  <div class="selectedFiles">Selected File/Files:</div>
                  {additionalDLFile.map((AdditionalDLFile) => (
                    <div class="fileUploadDocTitle">
                      <b>{AdditionalDLFile?.filename}<Button onClick={() => deleteFileCurrentDL(AdditionalDLFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                    </div>
                  ))}
                  <Button style={{ marginRight: '2.5px' }} component="label" variant="contained" className="fileUploadButton">
                    Add Files
                    <input
                      hidden
                      multiple
                      type="file"
                      onChange={uploadNewDL}
                      name="setAdditionalMoreDL"
                      id="docsDL"
                      disableUnderline={true}
                    />
                  </Button>
                  <Button style={{ marginLeft: '2.5px' }} onClick={clearNewDL} variant="outlined" className="fileClearButton">
                    Clear Files
                  </Button>

                  {/* <Button onClick={uploadNewAF} class='fileUploadButton'>Upload More Files</Button> */}
                </div>
              </Grid>

            </>

          ) : (
            additionalDLFile.length > 0 ? (
              <>
                <Grid sx={{ display: { xs: 'block', sm: 'none' }, marginTop: '20px' }}>
                  {additionalDLFile.map((AdditionalDLFile) => (
                    <div class="fileUploadDocTitle">
                      <b>{AdditionalDLFile?.filename}<Button onClick={() => deleteFileCurrentDL(AdditionalDLFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                    </div>
                  ))}
                  <Button variant="contained" component="label">
                    Add Files
                    <input
                      hidden
                      multiple
                      type="file"
                      onChange={uploadNewDL}
                      name="setAdditionalMoreDL"
                      id="docsDL"
                      disableUnderline={true}
                    />
                  </Button>
                </Grid>
                <Grid sx={{ display: { xs: 'none', sm: 'block' } }}>
                  <div className='fileContainter'>
                    <div class="selectedFiles">Selected File/Files:</div>
                    {additionalDLFile.map((AdditionalDLFile) => (
                      <div class="fileUploadDocTitle">
                        <b>{AdditionalDLFile?.filename}<Button onClick={() => deleteFileCurrentDL(AdditionalDLFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                      </div>
                    ))}
                    <Button variant="contained" component="label">
                      Add Files
                      <input
                        hidden
                        multiple
                        type="file"
                        onChange={uploadNewDL}
                        name="setAdditionalMoreDL"
                        id="docsDL"
                        disableUnderline={true}
                      />
                    </Button>
                    <Button onClick={clearDL} variant="outlined" color="error">
                      Clear
                    </Button>
                  </div>
                </Grid>
              </>
            ) : (
              <>
                <Grid sx={{ display: { xs: 'block', sm: 'none' }, marginTop: '20px' }}>
                  <Button
                    variant="contained"
                    component="label"
                  >
                    Upload Document
                    <input
                      className="form-control"
                      type="file"
                      onChange={onInputChangeDLDocs}
                      name="setAdditionalDL"
                      id="docsDL"
                      inputProps={{ multiple: true }}
                      hidden
                      disableUnderline={true}
                    />
                  </Button>
                </Grid>
                <Grid sx={{ display: { xs: 'none', sm: 'block' } }}>
                  <div class="form-group files">
                    <FormControl required={true}
                      fullWidth>
                      <Input
                        className="form-control"
                        type="file"
                        onChange={onInputChangeDLDocs}
                        name="setAdditionalDL"
                        id="docsDL"
                        inputProps={{ multiple: true }}
                        disableUnderline={true}
                      />
                    </FormControl>
                  </div>
                </Grid>
              </>
            )
          )
        }
        <Grid container paddingLeft={4}>
          <Grid item xs={12}>
          {psAdditionalDL.map((item, index) => (
                <Typography sx={{ textAlign: 'left', fontSize: '12px' }}>File Name: {item?.filename}</Typography>
              ))}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={12} lg={5.5} xl={5.5} marginTop={2}>
        <h3 class="fileUploadTitle">Other</h3>
        {
          applicantDetails?.additional_docs_files?.length > 0 ? (
            <>
              <Grid sx={{ display: { xs: 'block', sm: 'none' }, marginTop: '20px' }}>
                <div class="selectedFiles">Selected File/Files:</div>
                {additionalDocsFile.map((AdditionalDocsFile) => (
                  <div class="fileUploadDocTitle">
                    <b>{AdditionalDocsFile?.filename}<Button onClick={() => deleteFileCurrent(AdditionalDocsFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                  </div>
                ))}
                <Button style={{ marginRight: '2.5px' }} component="label" variant="contained" className="fileUploadButton">
                  Add Files
                  <input
                    hidden
                    multiple
                    type="file"
                    onChange={uploadNewAF}
                    name="setAdditionalMoreDocs"
                    id="docs"
                    disableUnderline={true}
                  />
                </Button>
                <Button style={{ marginLeft: '2.5px' }} onClick={clearNewOAR} variant="outlined" className="fileClearButton">
                  Clear Files
                </Button>
              </Grid>
              <Grid sx={{ display: { xs: 'none', sm: 'block' } }}>
                <div className='fileContainter'>
                  <div class="selectedFiles">Selected File/Files:</div>
                  {additionalDocsFile.map((AdditionalDocsFile) => (
                    <div class="fileUploadDocTitle">
                      <b>{AdditionalDocsFile?.filename}<Button onClick={() => deleteFileCurrent(AdditionalDocsFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                    </div>
                  ))}
                  <Button style={{ marginRight: '2.5px' }} component="label" variant="contained" className="fileUploadButton">
                    Add Files
                    <input
                      hidden
                      multiple
                      type="file"
                      onChange={uploadNewAF}
                      name="setAdditionalMoreDocs"
                      id="docs"
                      disableUnderline={true}
                    />
                  </Button>
                  <Button style={{ marginLeft: '2.5px' }} onClick={clearNewOAR} variant="outlined" className="fileClearButton">
                    Clear Files
                  </Button>

                  {/* <Button onClick={uploadNewAF} class='fileUploadButton'>Upload More Files</Button> */}
                </div>
              </Grid>

            </>

          ) : (
            additionalDocsFile.length > 0 ? (
              <>
                <Grid sx={{ display: { xs: 'block', sm: 'none' }, marginTop: '20px' }}>
                  {additionalDocsFile.map((AdditionalDocsFile) => (
                    <div class="fileUploadDocTitle">
                      <b>{AdditionalDocsFile?.filename}<Button onClick={() => deleteFileCurrent(AdditionalDocsFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                    </div>
                  ))}
                  <Button variant="contained" component="label">
                    Add Files
                    <input
                      hidden
                      multiple
                      type="file"
                      onChange={uploadNewAF}
                      name="setAdditionalMoreDocs"
                      id="docs"
                      disableUnderline={true}
                    />
                  </Button>
                </Grid>
                <Grid sx={{ display: { xs: 'none', sm: 'block' } }}>
                  <div className='fileContainter'>
                    <div class="selectedFiles">Selected File/Files:</div>
                    {additionalDocsFile.map((AdditionalDocsFile) => (
                      <div class="fileUploadDocTitle">
                        <b>{AdditionalDocsFile?.filename}<Button onClick={() => deleteFileCurrent(AdditionalDocsFile)} style={{ color: 'red', fontSize: '12px' }}>Delete</Button></b>
                      </div>
                    ))}
                    <Button variant="contained" component="label">
                      Add Files
                      <input
                        hidden
                        multiple
                        type="file"
                        onChange={uploadNewAF}
                        name="setAdditionalMoreDocs"
                        id="docs"
                        disableUnderline={true}
                      />
                    </Button>
                    <Button onClick={clearOAR} variant="outlined" color="error">
                      Clear
                    </Button>
                  </div>
                </Grid>
              </>
            ) : (
              <>
                <Grid sx={{ display: { xs: 'block', sm: 'none' }, marginTop: '20px' }}>
                  <Button
                    variant="contained"
                    component="label"
                  >
                    Upload Document
                    <input
                      className="form-control"
                      type="file"
                      onChange={onInputChangeAdditionalDocs}
                      name="setAdditionalDocs"
                      id="docs"
                      inputProps={{ multiple: true }}
                      hidden
                      disableUnderline={true}
                    />
                  </Button>
                </Grid>
                <Grid sx={{ display: { xs: 'none', sm: 'block' } }}>
                  <div class="form-group files">
                    <FormControl required={true}
                      fullWidth>
                      <Input
                        className="form-control"
                        type="file"
                        onChange={onInputChangeAdditionalDocs}
                        name="setAdditionalDocs"
                        id="docs"
                        inputProps={{ multiple: true }}
                        disableUnderline={true}
                      />
                    </FormControl>
                  </div>
                </Grid>
              </>
            )
          )
        }
        <Grid container paddingLeft={4}>
          <Grid item xs={12}>
          {psAdditionalDocs.map((item, index) => (
                <Typography sx={{ textAlign: 'left', fontSize: '12px' }}>File Name: {item?.filename}</Typography>
              ))}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={11} paddingBottom={2}>
        <StepButtons updateInfo={onUpdateDocumentsInfo} ref={ref} />
      </Grid>
    </Grid>
  )
}

export default forwardRef(Documents)